import { Helmet } from 'react-helmet-async';
import productImage from '../../assets/images/home_page_img_1.svg';

const ProductsPageHelmet = () => (
  <Helmet>
    {/* SEO Title */}
    <title>Buy Namasteji Manikchand Pan Masala Online | Best in India</title>

    {/* Meta Description  */}
    <meta
      name='description'
      content='Order Manikchand products online in India. Explore premium Namasteji Manikchand pan masala flavors, reviews, and prices from the best pan masala brand.'
    />

    {/* Keywords */}
    <meta
      name='keywords'
      content='
      Order manikchand products,
      buy Namasteji Manikchand online India,
      Namasteji Manikchand  pan masala flavor,
      Namasteji Manikchand review,
      Namasteji Manikchand price India
      '
    />

    {/* Canonical URL */}
    <link rel='canonical' href='https://globalmanikchand.in/products' />

    {/* Open Graph (Facebook / WhatsApp / Instagram) */}
    <meta property='og:type' content='website' />
    <meta property='og:title' content='Manikchand Pan Masala Online' />
    <meta
      property='og:description'
      content='Buy Namasteji Manikchand pan masala online. Discover authentic flavors, reviews, and prices from India’s best pan masala brand.'
    />
    <meta property='og:url' content='https://globalmanikchand.in/products' />
    <meta property='og:image' content={window.location.origin + productImage} />
    <meta property='og:site_name' content='Namasteji Manikchand Official' />
    <meta property='og:locale' content='en_IN' />

    {/* Twitter Card */}
    <meta name='twitter:card' content={window.location.origin + productImage} />
    <meta name='twitter:title' content='Manikchand Pan Masala Online' />
    <meta
      name='twitter:description'
      content='Buy Namasteji Manikchand pan masala online. Discover authentic flavors, reviews, and prices from India’s best pan masala brand.'
    />
    <meta name='twitter:image' content={window.location.origin + productImage} />
    <meta name='twitter:site' content='@NamastejiManikchand' />
  </Helmet>
);

export default ProductsPageHelmet;
